<template>
  <v-popover
    tag="div"
    content-tag="div"
    placement="top"
    class="footer-icon-wrap"
    :role="'poper'"
    :on-show="() => renderTooltip"
  >
    <em
      :style="getIconSyle"
      class="custom-icons small-card-info-icons"
    >
    </em>
    <template #content="{ state }">
      <RelatedCardsTooltip
        v-if="state.isVisible"
        :cards="cards"
        :relation-type="relationType"
      />
    </template>
  </v-popover>
</template>

<script setup lang="ts">
import { LinkedCardType } from '@superthread-com/api';
import { computed } from 'vue';
import RelatedCardsTooltip from '@/components/tooltips/RelatedCardsTooltip.vue';
import useCustomIcon from '@/utilities/composables/useCustomIcon';

const { iconPath, getCustomIconStyle } = useCustomIcon();

const props = defineProps({
  cards: {
    type: Array,
    required: true,
  },
  relationType: {
    type: String,
    required: true,
  },
  renderTooltip: {
    type: Boolean,
    default: false,
  },
});

const getIconSyle = computed(() => {
  let style = {};
  switch (props.relationType) {
    case LinkedCardType.BlockedBy:
      style = { ...getCustomIconStyle(iconPath('flag')), backgroundColor: '#FDB022' };
      break;
    case LinkedCardType.Blocks:
      style = { ...getCustomIconStyle(iconPath('black-flag')), backgroundColor: '#F97066' };
      break;
    default:
      break;
  }
  return style;
});
</script>
